import supabaseHandler from 'utils/SupaBase';

const getSupabase = () => {
    
    if (!supabaseHandler) {
        console.error('Supabase supabaseHandler not initialized - check environment variables');
        return null;
    }
    return supabaseHandler;
};

export const logout = async () => {
  const supabase = getSupabase();
  if (!supabase) {
    return { success: false, error: { message: "Supabase not initialized" } };
  }

  const { error } = await supabase.auth.signOut();

  // Always cleanup local state
  localStorage.removeItem("user");

  if (error) {
    console.error("Logout failed:", error.message);
  }

  // Hard redirect is safest for auth reset
  window.location.replace("/login");

  return { success: !error, error };
};


  export const getSession = async () => {
    const supabase = getSupabase();
    if (!supabase) return null;
    
    const { data, error } = await supabase.auth.getSession();
  
    if (error) {
      console.error('Error fetching session:', error.message);
      return null;
    }
  
    return data.session;
  };
  